/* eslint-disable class-methods-use-this */
import Cookie from 'universal-cookie';

const cookie = new Cookie();

const cookieDomain = process.env.NEXT_PUBLIC_COOKIE_DOMAIN || undefined;

class CookieService {
	get(key: string) {
		return cookie.get(key);
	}

	set(key: string, value: string, options: object) {
		const domainOptions = cookieDomain
			? { domain: cookieDomain, secure: true }
			: {};
		cookie.set(key, value, { ...options, ...domainOptions });
	}

	remove(key: string) {
		cookie.remove(key);
	}
}

export default new CookieService();
